export const PROPERTY_PLACEMAT_STRINGS = {
  'title.not_adopted_resident_and_home_not_loved':
    "Let's get your <span>home loved!</span>",
  'title.adopted_resident': 'Let us take over the <span>heavy lifting!</span>',
};
